import AppointmentFlowWizardContainer from './AppointmentFlowWizardContainer';

export default AppointmentFlowWizardContainer;



// WEBPACK FOOTER //
// ./src/components/templates/AppointmentFlowWizard/index.js